(function ($) {
  $('.main-header').each(function () {
    // Scroll
    var lastScrollTop = 0;
    $(window).scroll(function () {
      if ($(window).scrollTop() > 50) {
        $('.main-header').addClass('scrolled');
      } else {
        $('.main-header').removeClass('scrolled');
      }
      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        $('.main-header').removeClass('scrollUp').addClass('scrollDown');
      } else {
        $('.main-header').removeClass('scrollDown').addClass('scrollUp');
      }
      lastScrollTop = st;
    });

    // Burger
    $(document).on('click', ".main-header .toggle-menu", function () {
      $(this).toggleClass('open');
      $(this).attr("aria-expanded") == "true" ? $(this).attr("aria-expanded", "false") : $(this).attr("aria-expanded", "true");

      $('body').toggleClass('nav-open');
    });
  });
})(jQuery);
